







import { Component, Vue } from 'vue-property-decorator';
import BaseComponent from '../../../core/base.component';
import LoginLayout from './LoginLayout.layout.vue';

@Component({
  name: 'NonMainLayout',
  components: {
    LoginLayout,
  },
})
export default class NonMainLayout extends BaseComponent {}
